import { queryParamsModule } from '../../../../modules/queryParams';

import { layoutDataDefault } from './constants';

export const layoutQueryParams = {
  removeStepsData: () => {
    const existedParams = Object.keys(layoutDataDefault);
    existedParams.forEach((param) => {
      queryParamsModule.removeParam(param);
    });
    queryParamsModule.removeParam('step');
  },
};
